import getNodeName from "./auth-service-tools1153.js";

function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

export { isTableElement as default };